const initState = {};
const userReducer = (state = initState, action) => {
  switch (action.type) {
    case "UPDATE":
      return { ...action.data };
    case "CLEAR":
      return {};
    default:
      return { ...state };
  }
};

export default userReducer;
